import { render, staticRenderFns } from "./mobile-push-setting-form.vue?vue&type=template&id=b40dfc18"
import script from "./mobile-push-setting-form.vue?vue&type=script&lang=js"
export * from "./mobile-push-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports